import PropTypes from "prop-types";
import {useEffect, useRef} from "react";

const SuccessLabelArea = ({children }) => {

    const focusRef = useRef();
    useEffect(() => {
        focusRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }, [])

    return (
        <div className="alert alert-success" ref={focusRef}>
            {children}
        </div>
    );
}

SuccessLabelArea.propTypes = {
    children: PropTypes.element.isRequired,
}

SuccessLabelArea.defaultProps = {
    children: <></>,
}

export default SuccessLabelArea;


